import { UserSummaryDto } from './user-summary.dto';

export class UserSummary {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;

    constructor(dto: UserSummaryDto) {
        this.id = dto.id;
        this.firstName = dto.firstName;
        this.lastName = dto.lastName;
    }
}
